import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useState, useEffect } from "react"
import AdminTable from "../Administrator/Helpers/AdminTable"
import SureModal from "src/components/Modals/SureModal"
import EditComment from "./Modals/EditComment"
import dayjs from "dayjs"
import { Switch } from "antd"
import { statusAction, getClientsList } from "src/store/Slices/ClientsSlice";


const ClientsStatus = ({
  clientInfo,
  title,
  page,
  pageSize,
  setPage,
  setPageSize,
  mnemo,
  statusInfo,
  setStatusInfo,
  payload,
}) => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (clientInfo?.id) {
      console.log("statusAction:", statusAction);
      dispatch(
        statusAction({
          flag: "get",
          value: {
            userId: clientInfo.id,
            
          },
        })
      );
    }
    console.log("Dispatched statusAction")
  }, [clientInfo?.id, page, pageSize]);
 
  const items = [
    {
      key: "1",
      label: "Редактировать",
      onClick: () => {
        setIsOpenEditModal(true)
      },
      disabled: false,
    },
    {
      key: "2",
      label: "Удалить",
      onClick: () => {
        setOpenDeliteAbonementModal(true)
      },
      disabled: false,
    },
  ]

  const [isOpenEditModal, setIsOpenEditModal] = useState(false)
  const [openDeliteAbonementModal, setOpenDeliteAbonementModal] =
    useState(false)

  const statusList = useSelector(
    (state) => state.ClientsSlice.getClientStatusList
  )
  const statusListLoading = useSelector(
    (state) => state.ClientsSlice.getClientStatusListLoading
  )
   const totalCount = statusList?.value?.totalCount
  const searchItemsMap = (keys, values) => {
    const formattedItems = {}
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] != undefined && values[index][0] != undefined) {
          if (key === "contactDate") {
            formattedItems["ContactDate.From"] = dayjs(values[index][0]).format(
              "YYYY-MM-DD"
            )
            formattedItems["ContactDate.To"] = dayjs(values[index][1]).format(
              "YYYY-MM-DD"
            )
          } else if (key === "price") {
            formattedItems["Price.From"] = values[index][0]
            formattedItems["Price.To"] = values[index][1]
          } else if (key === "task") {
            formattedItems["task.From"] = dayjs(values[index][0]).format(
              "YYYY-MM-DD"
            )
            formattedItems["task.To"] = dayjs(values[index][1]).format(
              "YYYY-MM-DD"
            )
          } else {
            formattedItems[key] = values[index][0]
          }
        }
      })
      return formattedItems
    }
  }

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(Object.keys(filters), Object.values(filters))
    dispatch(
      statusAction({
        flag: "get",
        value: {
          userId: clientInfo?.id,
          count: pagination.pageSize,
          offset: pagination.pageSize * (pagination.current - 1),
          orderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          ...payload,
        },
      })
    )
    setPage(pagination.current)
    setPageSize(pagination.pageSize)
  }

  const onClickRowOne = (record) => {
    setStatusInfo(record) 
  }

  const onClickYesDeleteComment = () => {
    setOpenDeliteAbonementModal(false)
  }

  const handleComplete = (statusInfo) => {
    dispatch(
      statusAction({
        flag: "post",
        value: {
          userId: statusInfo?.id,
          isCompleted: !statusInfo?.isCompleted
        }

      })
    ).then(() => {
      console.log("then")
      dispatch(
        statusAction({
          flag: "get",
          value: {
            userId: clientInfo?.id,},
        })
      )
      dispatch(getClientsList(payload))
    })
  }
  const formatedStatusRows = statusList?.data?.value?.rows?.map((element) => {
    return {
      ...element,
      createdAt: element.createdAt
      ? dayjs(element?.createdAt).format("DD.MM.YYYY")
      : "",
      isCompleted: element?.isCompleted != null && (
        <Switch 
          onClick = {() => {
            setStatusInfo(element)
            handleComplete(element)
          }}
          defaultChecked
          value={element?.isCompleted}
        />)
    }
  }) 

  return (
    <>
      <SureModal
        visible={openDeliteAbonementModal}
        setVisible={setOpenDeliteAbonementModal}
        onClickYes={onClickYesDeleteComment}
      />
      <EditComment
        statusModal={isOpenEditModal}
        setStatusModal={setIsOpenEditModal}
        clientInfo={clientInfo}
        statusInfo={statusInfo}
        payload={payload}
      />
      {window.innerWidth >= 768 && (
        <AdminTable
          scroll={{ x: 0, y: 200 }}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={statusListLoading}
          // onClickRowOne={onClickRowOne}
          columns={statusList} 
          rows={formatedStatusRows}
          total={statusList?.data?.value?.totalCount}
          title={title}
          // items={items}
          // isAction={true}
        />
      )}
    </>
  )
}

export default ClientsStatus
